export enum TcddDialogView {
  TRAIN_OVERVIEW = 'trainOverview',      // train itself overview
  WAGON_DETAIL = 'wagonDetail',          // wagon opened / wagon detail view
  UNIT_DETAIL = 'unitDetail',            // unit with visual + info
  UNIT_VISUAL = 'unitVisual',            // only unit visual
  UNIT_3D_DETAIL = 'unit3DDetail',       // unit in 3D view + info
  UNIT_3D = 'unit3D'                     // unit in full 3D view
}
